<div
  [class.bg-transparent]="!showCard"
  [class]="showCard ? 'border rounded p-2 review-card' : ''"
>
  <div class="d-flex justify-content-between">
    <div>
      <div class="h4 pb-2 fw-bold" *scText="fields?.Title"></div>
      <div class="d-flex">
        <div
          class="score fw-bold d-flex justify-content-center align-items-center bg-brand h2 text-white p-4 m-0"
        >
          {{ stats.averageRating }}
        </div>
        <div class="d-flex justify-content-between flex-column ps-2">
          <wl-review-stars
            class="text-nowrap mb-1"
            [score]="stats.averageRating"
          ></wl-review-stars>
          <div class="review-card__text--desktop flex-column">
            <ng-container
              *ngTemplateOutlet="
                reviewAndRecommendation;
                context: {
                  totalReviews: stats.totalReviews,
                  recommendPercentage: stats.recommendPercentage,
                }
              "
            ></ng-container>
          </div>
        </div>
      </div>
    </div>
    @if (type === 'overview') {
      <div class="d-none d-lg-block">
        <ng-container
          *ngTemplateOutlet="klantenvertellenlogo; context: { size: 'large' }"
        ></ng-container>
      </div>
    }
  </div>
  <div class="review-card__text--mobile mt-2">
    <ng-container
      *ngTemplateOutlet="
        reviewAndRecommendation;
        context: {
          totalReviews: stats.totalReviews,
          recommendPercentage: stats.recommendPercentage,
        }
      "
    ></ng-container>
  </div>
  @if (type === 'overview') {
    <div class="d-lg-none mt-2">
      <ng-container
        *ngTemplateOutlet="klantenvertellenlogo; context: { size: 'large' }"
      ></ng-container>
    </div>
  }
  @if (type === 'entry') {
    <div class="mt-3">
      <ng-container
        *ngTemplateOutlet="klantenvertellenlogo; context: { size: 'large' }"
      ></ng-container>
      <div class="mt-3">
        <a [class]="buttonStyle" *wlGenericLink="fields?.ButtonLink"></a>
      </div>
    </div>
  }
  @if (type === 'small') {
    <div class="d-flex justify-content-between align-items-end mt-2">
      <a [class]="buttonStyle" *wlGenericLink="fields?.ButtonLink"></a>
      <ng-container
        *ngTemplateOutlet="klantenvertellenlogo; context: { size: 'small' }"
      ></ng-container>
    </div>
  }
</div>

<ng-template #klantenvertellenlogo let-size="size">
  <img
    [class]="'klanten-vertellen-logo__' + size"
    [src]="'assets/klantenvertellen-logo.svg' | deployUrl"
    alt="Klanten vertellen logo"
    loading="lazy"
  />
</ng-template>

<ng-template
  #reviewAndRecommendation
  let-totalReviews="totalReviews"
  let-recommendPercentage="recommendPercentage"
>
  <div class="d-flex align-items-center mb-1">
    <fa-icon class="text-success me-1 align-self-start" icon="check"></fa-icon>
    <div>
      <strong>{{ totalReviews }}&nbsp;</strong>
      <span *scText="fields?.ReviewAmountText"></span>
    </div>
  </div>
  <div class="d-flex align-items-center">
    <fa-icon class="text-success me-1 align-self-start" icon="check"></fa-icon>
    <div>
      <strong>{{ recommendPercentage }}%&nbsp;</strong>
      <span *scText="fields?.RecommendationText"></span>
    </div>
  </div>
</ng-template>
